/**
 * Publish/subscribe model on actions that can be performed on items
 * Allows communication between controllers. Also makes it simpler to see which controllers are involved in a channel
 *
 * Injections:
 *   -> $rootScope: to emit an event to listeners on the rootScope
 */
export function ItemStatusChannel($rootScope) {
    'ngInject';
    var ITEM_SELECTED = 'ITEM_SELECTED',
        ITEM_EDITED = 'ITEM_EDITED',
        selectItem,
        editItem,
        onSelectItem,
        onEditItem;

        /**
         * Emit a given event with a given args object
         * NOTE: we use $emit here because it will only emit to listeners on the rootScope
         */
    selectItem = function(args) {
        $rootScope.$emit(ITEM_SELECTED, args);
    };

    editItem = function(cartItem) {
        $rootScope.$emit(ITEM_EDITED, cartItem);
    };

    /**
         * The following functions will register a listener for a specific event
         * Must clean up listeners because they are registered on the $rootScope.
         *
         * NOTE: This means that if this $scope is destroyed, the callback functions to the listeners (e.g. $scope.itemClicked)
         * will not be destroyed as the listener on the $rootScope (which doesn't get destroyed on $scope changes) will
         * still have a reference to the callback.
         */
    onSelectItem = function($scope, callback) {
        var callbackCleanup = $rootScope.$on(ITEM_SELECTED, function(event, args) {
            callback(args.group, args.item);
        });

        $scope.$on('$destroy', function() {
            callbackCleanup();
        });
    };

    onEditItem = function($scope, callback) {
        var callbackCleanup = $rootScope.$on(ITEM_EDITED, function(event, cartItem) {
            callback(cartItem);
        });

        $scope.$on('$destroy', function() {
            callbackCleanup();
        });
    };

    return {
        selectItem: selectItem,
        editItem: editItem,
        onSelectItem: onSelectItem,
        onEditItem: onEditItem
    };
}
